import { useEffect, useState } from "react";

/** A button that asks once more in place ("Delete 3 notes forever?") before doing something irreversible. */
export function ConfirmButton({
  label,
  confirmLabel,
  onConfirm,
  busy,
  className = "btn btn-small btn-danger",
}: {
  label: string;
  confirmLabel: string;
  onConfirm: () => void;
  busy?: boolean;
  className?: string;
}) {
  const [asking, setAsking] = useState(false);
  useEffect(() => {
    if (!asking) return;
    const t = setTimeout(() => setAsking(false), 5000);
    return () => clearTimeout(t);
  }, [asking]);
  return asking ? (
    <span className="confirm-inline">
      <button
        className={`${className} confirming`}
        disabled={busy}
        onClick={() => {
          setAsking(false);
          onConfirm();
        }}
      >
        {confirmLabel}
      </button>
      <button className="btn btn-small" onClick={() => setAsking(false)}>
        Cancel
      </button>
    </span>
  ) : (
    <button className={className} disabled={busy} onClick={() => setAsking(true)}>
      {label}
    </button>
  );
}
